import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import Modal from '@tds/community-modal';
import { useHistory } from 'react-router-dom';
import { ADMIN_EMAIL } from '../utils/constant';

const RegistrationModel = ({ show }) => {
  const locale = localStorage.getItem('locale');
  const [showModal, setShowModal] = useState(show);
  const history = useHistory();
  const focusElementOnClose = useRef(null);
  const closeModal = () => {
    setShowModal(false);
    history.push('/login');
  };
  const proceed = () => {
    setShowModal(false);
    history.push('/login');
  };
  const engText = `EMAIL HAS BEEN SENT TO${' '} ${ADMIN_EMAIL} ${' '}FOR VERIFICATION. Please wait for confirmation to continue.`;
  const frText = `UN EMAIL A ÉTÉ ENVOYÉ À${' '} ${ADMIN_EMAIL} ${' '}POUR VÉRIFICATION. Veuillez attendre la confirmation pour continuer.`;

  return (
    <div>
      <Modal
        heading={
          locale === 'FR' ? "CONFIRMATION DE L'ÉMAIL" : 'EMAIL CONFIRMATION'
        }
        bodyText={locale === 'FR' ? frText : engText}
        confirmCTAText="OK"
        focusElementAfterClose={focusElementOnClose}
        onConfirm={proceed}
        onClose={closeModal}
        isOpen={showModal}
      />
    </div>
  );
};

RegistrationModel.defaultProps = {
  show: false
};

RegistrationModel.propTypes = {
  show: PropTypes.bool
};

export default RegistrationModel;
